import styled from "styled-components/macro";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  text-align: left;
  color: var(--grey-0);
  line-height: 1.5;
  font-family: "Inter";

  .credits-description {
    margin-bottom: 16px;
  }

  /* Container row for the "Show/Hide other plans" toggle that appears once a
     plan has been selected. The button itself is a sudokit SudoButton so
     it's keyboard-focusable; this row exists only to right-align it. */
  .plans-toggle-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .plans {
    margin-bottom: 16px;
    margin-top: 16px;
    /* Tabular numerals on the price text inside plan cards so the columns
       don't shift when interval/discount changes. */
    font-variant-numeric: tabular-nums;
  }

  .interval {
    margin-bottom: 16px;
    margin-top: 16px;
    display: flex;
    justify-content: center;
    /* Surface the discount label cleanly across the segmented control. */
    font-variant-numeric: tabular-nums;
  }

  .back-button {
    float: left;
    font-family: Inter;
    color: var(--grey-0);
    background: var(--menu-color);
    margin-bottom: 4px;

    svg {
      width: 16px;
      opacity: 1;
      path {
        fill: var(--grey-0);
        stroke: var(--grey-0);
      }
    }
  }

  /* Concentric border radius (12px inside the modal's 20px shell) and
     property-specific transitions in PlanCardList.styles.js. */
  .order-summary-container {
    border: 1px solid var(--grey-3);
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 16px;
    /* Prices line up cleanly across rows. */
    font-variant-numeric: tabular-nums;
  }

  .order-summary-plan-name {
    font-weight: 600;
    margin-bottom: 8px;
    margin-top: 16px;
  }

  .order-summary-table {
    display: flex;
    flex-direction: row;
    gap: 4px;
    justify-content: space-between;
    width: 50%;
    font-variant-numeric: tabular-nums;

    .order-summary-left {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .order-summary-right {
      display: flex;
      flex-direction: column;
      gap: 4px;
      align-items: flex-end;
    }

    .order-summary-total {
      margin-top: 8px;
      font-weight: 600;
    }
  }
`;
